<div class="table-responsive">
  <div class="tableMain">
    <div class="tableBox tableHead">
      <div class="tableCell cell-55">
        <a class="headlabel text-uppercase" href="javascript:void(0)">
          Behaviors
          <span class="iconList">
            <i class="icon-angle-right up" (click)="active='title';setOrder('title',false)"
              [class.active]="active==='title'"></i>
            <i class="icon-angle-right down" (click)="active='-title';setOrder('title',true)"
              [class.active]="active==='-title'"></i>
          </span>
        </a>
      </div>
      <div class="tableCell cell-30">
        <a class="headlabel text-uppercase" href="javascript:void(0)">
          Progress
          <span class="iconList">
            <i class="icon-angle-right up" (click)="active='performance';setOrder('performance',false)"
              [class.active]="active==='performance'"></i>
            <i class="icon-angle-right down" (click)="active='-performance';setOrder('performance',true)"
              [class.active]="active==='-performance'"></i>
          </span>
        </a>
      </div>
      <div class="tableCell cell-15 text-right">
        <a class="headlabel text-uppercase" href="javascript:void(0)">
          Score
          <span class="iconList">
            <i class="icon-angle-right up" (click)="active='progressPercentage';setOrder('progressPercentage',false)"
              [class.active]="active==='progressPercentage'"></i>
            <i class="icon-angle-right down" (click)="active='-progressPercentage';setOrder('progressPercentage',true)"
              [class.active]="active==='-progressPercentage'"></i>
          </span>
        </a>
      </div>
    </div>
    <div malihu-scrollbar class="scrollToFive">
      <div class="card">
        <div *ngFor="let score of behaviourScore |orderBy: order:reverse:'case-insensitive'" class="card-header">
          <div class="pl-4 pr-4">
            <div class="tableBox align-items-center">
              <div class="tableCell cell-55">
                <div class="nameList text-capitalize">
                  <label>{{score.title}}</label>
                </div>
              </div>

              <div class="tableCell cell-30">
                <div class="progressBox">
                  <span class="textLabel">{{score.progressPercentage | number:'1.0-0'}}%</span>
                  <div class="progress progress-h-sm">
                    <div class="progress-bar warning" [class.success]="score.progressPercentage == 100"
                      [ngStyle]="{'width': score.progressPercentage+'%'}"></div>
                  </div>
                </div>
              </div>
              <div class="tableCell cell-15">
                <div class="d-flex align-items-center justify-content-end circle-progress">
                  <p class="textLabel text-capitalize" style="width: 60px;">{{score.performance | number:'1.0-0'}}%</p>
                  <circle-progress [showTitle]="false" [showSubtitle]="false" [showUnits]="false"
                    [percent]="(score?.gainedMarks / score?.totalMarks) * 100" [radius]="18" [space]="-5" [toFixed]="0"
                    [maxPercent]="100" [unitsFontSize]="10" [unitsColor]="'#e27137'" [outerStrokeWidth]="5"
                    [outerStrokeColor]="'#e27137'" [innerStrokeColor]="'#f9e3d7'" [innerStrokeWidth]="5"
                    [titleColor]="'#e27137'" [titleFontSize]="14" [subtitleFontSize]="6">
                  </circle-progress>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
